document.addEventListener('click', async function (event) {
  const loadMoreBtn = event.target.closest('.collection-load-more-button');
  if (!loadMoreBtn) return;

  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) return;

  const nextPage = parseInt(loadMoreBtn.dataset.nextPage, 10);
  const totalPages = parseInt(loadMoreBtn.dataset.totalPages, 10);
  if (!nextPage || nextPage > totalPages) {
    loadMoreBtn.style.display = 'none';
    return;
  }

  loadMoreBtn.disabled = true;
  const originalLabel = loadMoreBtn.textContent;
  loadMoreBtn.textContent = 'Loading...';

  try {
    const url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);
    url.searchParams.set('section_id', 'main-collection-product-grid');

    const response = await fetch(url.href);
    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const newGrid = doc.querySelector('#product-grid');
    const newItems = newGrid ? Array.from(newGrid.children) : [];

    if (newItems.length) {
      newItems.forEach(item => productGrid.appendChild(item));
      loadMoreBtn.dataset.nextPage = nextPage + 1;
    }

    if (nextPage >= totalPages || newItems.length === 0) {
      loadMoreBtn.style.display = 'none';
    }
  } catch (err) {
    console.error('Load more failed:', err);
  } finally {
    loadMoreBtn.disabled = false;
    loadMoreBtn.textContent = originalLabel;
  }
});
